module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction"
    }
  }, [_vm._v("Introduction: A City Built on Bones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part01"
    }
  }, [_c('b', [_vm._v("Part I: Early Days")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part01#h1"
    }
  }, [_vm._v("Fort Brooke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part01#h2"
    }
  }, [_vm._v("The Fort Brooke Parking Garage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part01#h3"
    }
  }, [_vm._v("The Legend of Jose Gaspar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part II: The Old City Cemetery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part02#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oaklawn Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part02#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dr. John P. Wall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part02#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vincent Martinez de Ybor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part02#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Owen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part02#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mayor Lancaster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part02#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Darwin Branch Givens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part02#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William and Nancy Ashley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part02#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St. Paul’s AME Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part III: Downtown")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hotel Floridan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tampa Theatre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Duckweed Urban Market")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Five and Dime” Block")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Federal Courthouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tampa Police Memorial")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mad Russian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old City Hall and a Clock Named Hortense")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Tampa Book Company")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sykes Building")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part03#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scrub and the Jackson House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part IV: Across the River")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part04#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Falk Theatre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part04#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plant Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part V: Around the Bay")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part05#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sunshine Skyway Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part05#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ringling Ghosts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part05#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Howard W. Blake High School")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part05#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grey Lady")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part05#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sulphur Springs Water Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0